<ng-container *ngIf="cashbackBenefit$ | async as benefit">
  <div *ngIf="benefitStyle$ | async as benefitStyle" class="benefitCashback__cont benefitCashback__cont--{{benefitViewType}}">
    <div class="benefitCashback__divider-line benefitCashback__divider-line--{{benefitViewType}}">
      <app-ds-divider></app-ds-divider>
    </div>
    <div class="benefitCashback__info benefitCashback__info--{{benefitViewType}}">
      <ng-container *ngIf="isCombined(benefitStyle); else icon">
        <img alt="Card+Pro Benefit" loading="lazy" [src]="CARD_PRO_IMG | baseImage: CARD_PRO_ROUTE">
      </ng-container>
        <ng-template #icon>
          <span class="benefitCashback__icon--{{benefitStyle}}">
            <app-ds-icon
              class="benefitCashback__icon"
              [icon]="benefitIcon(benefitStyle)"
              [color]="iconColor(benefitStyle)"
              [size]="'20'">
            </app-ds-icon>
          </span>
        </ng-template>
      <p class="benefitCashback__text benefitCashback__text--{{benefitStyle}}" [innerHTML]="cashbackBenefitLabel$(benefit, benefitStyle) | async"></p>
    </div>
  </div>
</ng-container>